import { EVENTS, track, registerUrlSuperProps } from "../utils/analytics"

/**
 * Tier 2 page views. The SDK is initialised with `track_pageview: false`
 * because hub is an SPA — the SDK's own pageview tracking would fire once on
 * boot and never again.
 *
 * `page_route` is the file-based route name (e.g. `orders-id`), which is the
 * low-cardinality key to group on. `page_path` keeps the concrete URL for
 * drill-down. Note that dynamic route ids are deliberately NOT in `page_path`'s
 * grouping role — an order id per row would blow up cardinality.
 */
let leftPreviousPageAt: number | null = null

export default defineNuxtRouteMiddleware((to, from) => {
	if (!import.meta.client) return
	if (from && to.fullPath === from.fullPath) return

	const now = Date.now()
	const timeOnPrevious = leftPreviousPageAt === null ? undefined : now - leftPreviousPageAt
	leftPreviousPageAt = now

	// Before the event: $identify and other SDK-internal events bypass track(),
	// so only a super property keeps the raw query string off them.
	registerUrlSuperProps()

	track(EVENTS.PAGE_VIEWED, {
		page_route: to.name,
		page_path: to.path,
		referrer_path: from?.path,
		time_on_previous_page_ms: timeOnPrevious,
	})
})
